import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import SessionActionTypeEnum from 'FormSwiftAPI/Session/SessionConstants';

export const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);

const saveSessionRequest = () => (
  (dispatch) => {
    dispatch({ type: SessionActionTypeEnum.SAVE_SESSION_REQUEST });
  }
);

const saveSessionSuccess = saveValue => (
  (dispatch) => {
    dispatch({ type: SessionActionTypeEnum.SAVE_SESSION_SUCCESS, autoSaveValue: saveValue });
  }
);

const saveSessionFailure = error => (
  (dispatch) => {
    dispatch({ type: SessionActionTypeEnum.SAVE_SESSION_FAILURE, error: error.message });
  }
);

export const gracefulSave = (savingFunc, savingArgs) => (
  async (dispatch, getState) => {
    try {
      const sessionState = getState().FormSwiftAPIHandler.SessionHandler;
      if (!sessionState.isSaving) {
        dispatch(saveSessionRequest());
        await dispatch(savingFunc(savingArgs));
        dispatch(saveSessionSuccess(savingArgs));
      }
    } catch (e) {
      dispatch(saveSessionFailure(e));
    }
  }
);



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/Session/SessionActions.jsx